import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";

import { getEntityTypeAnalyticsName } from "@app/util/ui";

const getMapFilterTypeForAnalytics = (
  entityType: MapFilterEntityType,
  lowercase: boolean = false
) => {
  if (entityType === "universal") {
    return lowercase ? "universal" : "Universal";
  }
  return getEntityTypeAnalyticsName(entityType, lowercase, false);
};

export default getMapFilterTypeForAnalytics;
